import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import {Hub, Tag} from 'yougile-model'
import {Sync} from '@client/sync'
import {PinStickersMenu} from '@components/sticker/pin-sticker-menu'
import {useBoard} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {Sticker} from '@extensions/sticker/sticker'
import {useMultiActionsWithTasksStore} from '../multi-actions-with-tasks-store'
import {AssignedSticker} from './assigned-sticker'
import {DeadlineSticker} from './deadline-sticker'
import {RenderSticker} from './render-sticker'

export const StickerMenu = observer(() => {
  const [state, store] = useMultiActionsWithTasksStore()
  const board = useBoard()
  const ref = useRef(null)
  const box = Sync.getCurrentSandbox()
  const task = new Hub(box.companyId, 'test')
  const type = state.tag && Sticker.getType(state.tag)

  const turnOff = (close?: boolean) => {
    if (!state.tag) {
      return
    }

    store.setStickerState(task.stickers[state.tag.id])
    store.setTagOpen(false)

    if (type !== 'deadline' && type !== 'user' && state.stickerState) {
      store.setApplyCustomStickerPopup(true)
    } else if (state.deadlineValue || close) {
      store.visibleOff()
    }
  }

  const stickerTags = Sticker.list(board)
  if (!stickerTags.some(x => Sticker.getType(x) === 'user')) {
    stickerTags.push(
      Sticker.getUserSticker({companyId: globals.getCompanyId()})
    )
  }
  const index = stickerTags.findIndex(item => Sticker.getType(item) === 'user')
  stickerTags.unshift(stickerTags.splice(index, 1)[0])

  const items: Tag[] = stickerTags.filter(item => {
    const type = Sticker.getType(item)
    return ['user', 'deadline', 'string', 'sprint'].includes(type)
  })

  const onClickOnMenuItem = (tag: Tag) => {
    store.setTag(tag)
    store.setTagOpen(true)
  }

  return (
    <div className="flex" ref={ref}>
      {(state.tagOpen && (type === 'deadline' || type === 'user')) ||
      state.applyCustomStickerPopup ? null : (
        <PinStickersMenu stickers={items} onClick={onClickOnMenuItem} />
      )}
      {state.tagOpen && type === 'deadline' && (
        <DeadlineSticker task={task} cb={turnOff} ref={ref} />
      )}
      {state.tagOpen && type === 'user' && (
        <AssignedSticker task={task} cb={turnOff} ref={ref} />
      )}
      {state.tagOpen && type !== 'deadline' && type !== 'user' && (
        <RenderSticker task={task} cb={turnOff} />
      )}
    </div>
  )
})
